import { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { getUserData } from "../../store/ducks/currentUser/actions";
import { getCountry } from "../../store/ducks/home/actions"; 
import { detectCountry, getBrowserLanguage } from "../../hoc/Shared/utility";

class CountrySetting extends Component {
    constructor(props){
        super(props);
    }

    componentDidMount(){
        // console.log("System props", this.props.currentUser, this.props.location, localStorage.getItem("changeCountry"), localStorage.getItem("accessToken"));
        // checkDomain is guaranteed to only run when the member is not logged in.
        if(!localStorage.getItem("accessToken") && !localStorage.getItem("changeCountry")){
            this.props.getCountry();
            this.checkDomain();
        }
        else{
            // changed lang or logged in, do ntg for now
        }
    }

    componentDidUpdate(prevProps) {
        // checkDomain is guaranteed to only run when the member is not logged in.
        if (!localStorage.getItem("accessToken") && !localStorage.getItem("changeCountry") && prevProps.countries !== this.props.countries) {
            this.checkDomain();
        }
    }

    /**
     * 1. lookup the `countryCode` from `domain.json`.
     * 
     * 2. read the list of supported languages from GET /api/v1/member/country
     * 
     * 3. determine what languages are supported by the country i.e. Malaysia supports English, Chinese & Malay
     * 
     * 4. detect the browser language.
     * 
     * 5. determine if the browser language is supported by the country.
     * 
     * 6. if the browser language is supported and localStorage has no `lang`, use the browser language.
     */
    checkDomain = () => {
        let dynamicCountry = detectCountry(window.location.host);
        let domainContent = dynamicCountry.data;
        const countryCode = domainContent[0]; // e.g MY, TH, ID, VN, US
        // console.log(`countryCode=${countryCode}`);
        
        // props.countries is read from /api/member/v1/country
        // each country has a list of supported languages
        let supportedLanguages = this.props.countries?.language.filter(language => language.countryShortCode === countryCode) || [];
        // console.log(`languages supported by countryCode=${countryCode} | languages=${JSON.stringify(supportedLanguages, null, 2)}`);

        // find what language code is the browser using
        const browserLanguage = getBrowserLanguage();
        // console.log(`detected browserLanguage=${browserLanguage}`);

        // check if browser language is in the list of supported languages
        const supportedBrowserLanguage = supportedLanguages.find(language => language.languageCode === browserLanguage);
        // console.log(`supportedBrowserLanguage by countryCode=${countryCode} | supportedBrowserLanguage=${JSON.stringify(supportedBrowserLanguage, null, 2)}`);
        
        const data = {};
        // if domain didnt specify in json file, default show country MY data regardless of domain
        if(domainContent === null) {
            data.country_code = "MY";
            data.country_id = 1;
            data.language_code = "en";
            data.language_id = 1;
            data.time_zone = "Asia/Kuala_Lumpur";
            data.member_group_id = 1;
        } else {
            data.country_code = domainContent[0];
            data.country_id = domainContent[1];
            data.language_code = domainContent[2];
            data.language_id = domainContent[3];
            data.time_zone = domainContent[4];
            data.member_group_id = domainContent[5];
        }

        // Check if `lang` exists in localStorage
        const storedLang = localStorage.getItem('lang');

        // determine whether to override the language or not
        if (!storedLang && supportedBrowserLanguage) {
            // use browser language as it's truthy
            data.language_code = supportedBrowserLanguage.languageCode;
            data.language_id = supportedBrowserLanguage.languageId;

            // console.log(`changing language | language_code=${data.language_code} | language_id=${data.language_id}`);
            // see i18n.js for explanation as of why .toLowerCase() and replace ('-', '_') are used.
            this.props.i18n.changeLanguage(data.language_code.toLowerCase().replace('-', '_'));
        } 

        this.props.getUserData(data);
    }

    render(){
        return null;
    }
}

const mapStateToProps = state => {

    return {
        currentUser: state.currentUser,
        countries: state.home.country_data
    }
}

const mapDispatchToProps = {
    getUserData,
    getCountry,
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(CountrySetting));